import Step from './Step';
import Steps from './Steps';

Steps.Step = Step;
export default Steps;
